import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "data-table-empty is-compact"
};
const _hoisted_2 = ["data-comment-id"];
const _hoisted_3 = {
  class: "flex items-start gap-3"
};
const _hoisted_4 = {
  class: "flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-100 text-xs font-medium text-slate-600"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "min-w-0 flex-1"
};
const _hoisted_8 = {
  class: "flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1"
};
const _hoisted_9 = {
  class: "text-sm font-medium text-slate-800"
};
const _hoisted_10 = {
  class: "text-xs text-slate-400"
};
const _hoisted_11 = {
  key: 0,
  class: "status-badge mt-1.5 is-orange"
};
const _hoisted_12 = {
  class: "mt-1.5 break-words whitespace-pre-wrap text-sm leading-6 text-slate-600"
};
const _hoisted_13 = {
  key: 1,
  class: "mt-2 flex justify-end"
};
const _hoisted_14 = ["disabled", "onClick"];
const _hoisted_15 = {
  key: 2,
  class: "mt-3 rounded-lg bg-slate-50 px-3 py-2 text-sm leading-6 text-slate-600"
};
const _hoisted_16 = ["data-comment-id"];
const _hoisted_17 = {
  class: "flex flex-wrap items-baseline gap-x-1 gap-y-0.5"
};
const _hoisted_18 = {
  class: "font-medium text-slate-800"
};
const _hoisted_19 = {
  class: "font-medium text-slate-800"
};
const _hoisted_20 = {
  class: "min-w-0 flex-1 break-words whitespace-pre-wrap"
};
const _hoisted_21 = {
  key: 1,
  class: "status-badge is-orange"
};
const _hoisted_22 = ["disabled", "onClick"];
const _hoisted_23 = {
  class: "mt-0.5 block text-xs text-slate-400"
};
const _hoisted_24 = {
  class: "space-y-3"
};
const _hoisted_25 = {
  key: 0,
  class: "rounded-lg border border-blue-200 bg-blue-50 px-3 py-2"
};
const _hoisted_26 = {
  class: "flex flex-wrap items-start justify-between gap-2"
};
const _hoisted_27 = {
  class: "min-w-0"
};
const _hoisted_28 = {
  class: "text-sm font-medium text-blue-800"
};
const _hoisted_29 = {
  class: "mt-0.5 break-words text-xs leading-5 text-blue-700"
};
const _hoisted_30 = {
  class: "block"
};
const _hoisted_31 = {
  class: "form-label"
};
const _hoisted_32 = ["placeholder", "disabled"];
const _hoisted_33 = {
  class: "mt-3 flex flex-wrap justify-end gap-2"
};
const _hoisted_34 = ["disabled"];
const _hoisted_35 = ["disabled"];
import { computed, nextTick, ref, watch } from 'vue';
import { useUserStore } from '@/stores/user';
export default {
  __name: 'ReportCommentPanel',
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    canSubmit: {
      type: Boolean,
      default: true
    },
    canRequestSupplement: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focusCommentId: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['submit', 'request-supplement'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const userStore = useUserStore();
    const items = computed(() => Array.isArray(props.comments) ? props.comments : []);
    const commentsById = computed(() => {
      const map = new Map();
      items.value.forEach(comment => {
        const id = normalizedId(comment?.id);
        if (id) map.set(id, comment);
      });
      return map;
    });
    const rootComments = computed(() => items.value.filter(comment => threadRootOf(comment) === comment));
    const replyCommentsByRootId = computed(() => {
      const map = new Map();
      items.value.forEach(comment => {
        const root = threadRootOf(comment);
        if (root === comment) return;
        const rootId = normalizedId(root?.id);
        if (!rootId) return;
        const comments = map.get(rootId) || [];
        comments.push(comment);
        map.set(rootId, comments);
      });
      return map;
    });
    const focusedCommentId = computed(() => normalizedId(props.focusCommentId));
    const currentUserId = computed(() => normalizedId(userStore.userInfo?.userId || userStore.userInfo?.id));
    const content = ref('');
    const replyingTo = ref(null);
    const listRef = ref(null);
    const textareaRef = ref(null);
    watch(() => [focusedCommentId.value, items.value.length], () => scrollFocusedCommentIntoView(), {
      immediate: true
    });
    watch(items, () => {
      if (!replyingTo.value) return;
      const replyId = normalizedId(replyingTo.value.id);
      if (replyId && commentsById.value.has(replyId)) return;
      cancelReply();
    });
    function authorOf(comment) {
      return comment?.authorName || comment?.commenterName || comment?.author?.displayName || comment?.author?.name || comment?.author?.username || (comment?.authorUserId ? `用户 ${comment.authorUserId}` : '未署名');
    }
    function avatarOf(comment) {
      return comment?.authorAvatarUrl || comment?.avatarUrl || comment?.author?.avatarUrl || comment?.authorAvatar || comment?.avatar || comment?.author?.avatar || '';
    }
    function authorUserIdOf(comment) {
      return normalizedId(comment?.authorUserId || comment?.commenterUserId || comment?.userId || comment?.author?.id || comment?.author?.userId);
    }
    function isOwnComment(comment) {
      const current = currentUserId.value;
      const author = authorUserIdOf(comment);
      return Boolean(current && author && current === author);
    }
    function canReplyTo(comment) {
      return props.canSubmit && !props.disabled && !isOwnComment(comment);
    }
    function initials(comment) {
      const name = authorOf(comment);
      if (name === '未署名') return '?';
      return name.slice(0, 2).toUpperCase();
    }
    function parentCommentOf(comment) {
      const parentId = normalizedId(comment?.parentCommentId);
      return parentId ? commentsById.value.get(parentId) : null;
    }
    function threadRootOf(comment) {
      let current = comment;
      const visited = new Set();
      while (current) {
        const currentId = normalizedId(current?.id);
        if (currentId) {
          if (visited.has(currentId)) return comment;
          visited.add(currentId);
        }
        const parent = parentCommentOf(current);
        if (!parent) return current;
        current = parent;
      }
      return comment;
    }
    function replyTargetOf(reply) {
      return parentCommentOf(reply);
    }
    function replyCommentsOf(comment) {
      const rootId = normalizedId(comment?.id);
      return rootId ? replyCommentsByRootId.value.get(rootId) || [] : [];
    }
    function contentOf(comment) {
      return comment?.content || comment?.comment || '--';
    }
    function commentTimeOf(comment) {
      return comment?.createTime || comment?.createdAt || comment?.commentTime || '--';
    }
    function commentExcerpt(comment) {
      const text = String(contentOf(comment)).trim();
      if (!text || text === '--') return '暂无内容';
      return text.length > 48 ? `${text.slice(0, 48)}...` : text;
    }
    function commentItemClass(comment) {
      const id = normalizedId(comment?.id);
      if (!id || id !== focusedCommentId.value) return '';
      return 'bg-blue-50/70 ring-1 ring-inset ring-blue-200';
    }
    function startReply(comment) {
      if (!canReplyTo(comment)) return;
      replyingTo.value = comment;
      nextTick(() => textareaRef.value?.focus());
    }
    function cancelReply() {
      replyingTo.value = null;
    }
    function submitComment() {
      if (!props.canSubmit) return;
      const normalizedContent = content.value.trim();
      if (!normalizedContent) return;
      emit('submit', {
        parentCommentId: replyingTo.value?.id || null,
        content: normalizedContent
      });
      content.value = '';
      cancelReply();
    }
    function requestSupplement() {
      if (!props.canRequestSupplement) return;
      const normalizedContent = content.value.trim();
      if (!normalizedContent) return;
      emit('request-supplement', {
        content: normalizedContent
      });
      content.value = '';
      cancelReply();
    }
    function scrollFocusedCommentIntoView() {
      const id = focusedCommentId.value;
      if (!id) return;
      nextTick(() => {
        const nodes = Array.from(listRef.value?.querySelectorAll('[data-comment-id]') || []);
        const target = nodes.find(node => node.getAttribute('data-comment-id') === id);
        target?.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      });
    }
    function normalizedId(value) {
      if (value === null || value === undefined || value === '') return '';
      return String(value);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", null, [items.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, "暂无评论")) : (_openBlock(), _createElementBlock("ol", {
        key: 1,
        ref_key: "listRef",
        ref: listRef,
        class: "divide-y divide-slate-100 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rootComments.value, (comment, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: comment.id || index,
          class: _normalizeClass(["px-5 py-4 transition-colors", commentItemClass(comment)]),
          "data-comment-id": comment.id || ''
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [avatarOf(comment) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: avatarOf(comment),
          alt: `${authorOf(comment)}头像`,
          class: "h-full w-full object-cover"
        }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(initials(comment)), 1))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(authorOf(comment)), 1), _createElementVNode("time", _hoisted_10, _toDisplayString(commentTimeOf(comment)), 1)]), comment.supplementRequested ? (_openBlock(), _createElementBlock("span", _hoisted_11, "请求补充")) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_12, _toDisplayString(contentOf(comment)), 1), canReplyTo(comment) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("button", {
          type: "button",
          class: "text-xs font-medium text-blue-600 transition-colors hover:text-blue-700",
          disabled: __props.disabled,
          onClick: $event => startReply(comment)
        }, " 回复 ", 8, _hoisted_14)])) : _createCommentVNode("", true), replyCommentsOf(comment).length ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replyCommentsOf(comment), reply => {
          return _openBlock(), _createElementBlock("div", {
            key: reply.id || `${comment.id || index}-reply-${contentOf(reply)}`,
            class: _normalizeClass(["rounded-md px-2 py-1 transition-colors", commentItemClass(reply)]),
            "data-comment-id": reply.id || ''
          }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(authorOf(reply)), 1), replyTargetOf(reply) ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_cache[1] || (_cache[1] = _createElementVNode("span", {
            class: "text-slate-400"
          }, "回复", -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(authorOf(replyTargetOf(reply))), 1)], 64)) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("span", {
            class: "text-slate-400"
          }, "：", -1)), _createElementVNode("span", _hoisted_20, _toDisplayString(contentOf(reply)), 1), reply.supplementRequested ? (_openBlock(), _createElementBlock("span", _hoisted_21, "请求补充")) : _createCommentVNode("", true), canReplyTo(reply) ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "ml-auto text-xs font-medium text-blue-600 transition-colors hover:text-blue-700",
            disabled: __props.disabled,
            onClick: $event => startReply(reply)
          }, " 回复 ", 8, _hoisted_22)) : _createCommentVNode("", true)]), _createElementVNode("time", _hoisted_23, _toDisplayString(commentTimeOf(reply)), 1)], 10, _hoisted_16);
        }), 128))])) : _createCommentVNode("", true)])])], 10, _hoisted_2);
      }), 128))], 512)), __props.canSubmit || __props.canRequestSupplement ? (_openBlock(), _createElementBlock("form", {
        key: 2,
        class: "mt-4 rounded-xl border border-slate-200 bg-white p-4 shadow-sm",
        onSubmit: _withModifiers(submitComment, ["prevent"])
      }, [_createElementVNode("div", _hoisted_24, [replyingTo.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, "回复 @" + _toDisplayString(authorOf(replyingTo.value)), 1), _createElementVNode("p", _hoisted_29, _toDisplayString(commentExcerpt(replyingTo.value)), 1)]), _createElementVNode("button", {
        type: "button",
        class: "text-xs font-medium text-blue-700 hover:text-blue-900",
        onClick: cancelReply
      }, "取消回复")])])) : _createCommentVNode("", true), _createElementVNode("label", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(replyingTo.value ? '回复内容' : '评论'), 1), _withDirectives(_createElementVNode("textarea", {
        ref_key: "textareaRef",
        ref: textareaRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => content.value = $event),
        class: "form-textarea mt-1 w-full",
        rows: "3",
        placeholder: replyingTo.value ? `回复 @${authorOf(replyingTo.value)}` : '请输入评论内容',
        disabled: __props.disabled
      }, null, 8, _hoisted_32), [[_vModelText, content.value, void 0, {
        trim: true
      }]])])]), _createElementVNode("div", _hoisted_33, [__props.canRequestSupplement ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "btn-secondary",
        disabled: __props.disabled || !content.value,
        onClick: requestSupplement
      }, "要求补充", 8, _hoisted_34)) : _createCommentVNode("", true), __props.canSubmit ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "submit",
        class: "btn-secondary",
        disabled: __props.disabled || !content.value
      }, _toDisplayString(replyingTo.value ? '提交回复' : '提交评论'), 9, _hoisted_35)) : _createCommentVNode("", true)])], 32)) : _createCommentVNode("", true)]);
    };
  }
};